<template>
  <div v-if="value?.length">
    <div
      v-for="(riskTiers, index) in value"
      :key="index"
      class="my-5 flex whitespace-nowrap"
    >
      <risk-tier
        v-for="(tier, index) in riskTiers"
        :key="index"
        :modelValue="tier"
        uppercase
        bordered
        class="mr-1"
      />
    </div>
  </div>
  <div v-else>-</div>
</template>
<script lang="ts" setup>
import RiskTier from "@/components/RiskTier.vue";

defineProps<{
  value?: number[];
}>();
</script>
